var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 42,
    viewBox: "0 0 26 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7101 0L12.4301 0.94V28.33L12.7101 28.61L25.4201 21.09L12.7101 0Z",
    fill: "#D12663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71 0L0 21.09L12.71 28.61V15.31V0Z",
    fill: "#E06A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71 31.01L12.55 31.2V40.96L12.71 41.41L25.43 23.5L12.71 31.01Z",
    fill: "#CE2561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71 41.41V31.01L0 23.5L12.71 41.41Z",
    fill: "#E06A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71 28.61L25.42 21.09L12.71 15.31V28.61Z",
    fill: "#570D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21.09L12.71 28.61V15.31L0 21.09Z",
    fill: "#CE2561"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.43,
    height: 41.41,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthBig);
export default __webpack_public_path__ + "static/media/eth_big.779b81fe4e5475ffcf6778b415a34a5e.svg";
export { ForwardRef as ReactComponent };